<template>
  <v-card class="t-datetime-picker white">
    <v-toolbar height="36" color="primary" dark flat>
      <v-tabs v-model="tab" grow height="36">
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab href="#date">
          <v-icon>mdi-calendar</v-icon>
        </v-tab>
        <v-tab href="#time">
          <v-icon>mdi-clock</v-icon>
        </v-tab>
        <v-btn depressed text class="rounded-0"
               @click="$emit('updatedDateTime', [eventSelected, time, date, false])">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <v-tab-item value="date">
        <v-date-picker v-model="date" class="rounded-0" :min="minDate" @input="tab = 'time'" full-width locale="fr"
                       color="#1A4A56"></v-date-picker>
      </v-tab-item>
      <v-tab-item value="time">
        <v-time-picker
            :key="tab"
            v-model="time"
            format="24hr"
            class="rounded-0"
            full-width
            locale="fr"
            color="#1A4A56"
        >
        </v-time-picker>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  name: 'DatetimePicker',
  props: ['eventSelected'],
  data () {
    return {
      tab: false,
      date: null,
      time: null,
      minDate: new Date().toISOString().substr(0, 10)
    }
  },
  mounted () {
    if (this.eventSelected) {
      const dateSplited = this.eventSelected.start.split(' ')
      this.date = dateSplited[0]
      this.time = dateSplited[1]
    }
  }
}
</script>
